import React, { FC } from 'react';
import styled from 'styled-components';

import Link from '@/components/Link/Link';
import { Text } from '@/components/Text';
import { formatDate } from '@/helpers/formatDate';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';
import { devices } from '@/styles/breakpoints';
import { IBlog } from '@/types/blog';

interface IProps {
  item: IBlog;
  type: string;
}

export const BigCard: FC<IProps> = ({ item, type = 'blog' }) => {
  const [image] = JSON.parse(item.image);

  function addArticleJsonLd() {
    return {
      __html: `{
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": ${JSON.stringify(item?.title)},
        "description": ${JSON.stringify(item?.meta_description)},
        "image": ["${image?.preview_source}"],
        "publisher": {
          "@type": "Organization",
          "name": "Collaborator",
          "logo": {
            "@type": "ImageObject",
            "url": "${image?.preview_source}",
            "width": 150,
            "height":150
          }
        },
        "datePublished": "${new Date(item.created_at).toISOString()}",
        "dateModified": "${new Date(item.created_at).toISOString()}",
        "author": [{
          "@type": "Person",
          "name": "Alex G",
          "url": "https://orcatec.com"
        }]
      }`,
    };
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addArticleJsonLd()}
        key="articles-jsonld"
      />
      <Wrapper href={`/${type}/${item.slug}`}>
        <Overlay src={image.source}>
          <OverlayGradient>
            <Content>
              <Time>{formatDate(item.created_at)}</Time>
              <Desciption>{item.meta_title}</Desciption>
              {/* <Text
              dangerouslySetInnerHTML={{ __html: item.short_description }}
              style={{ color: 'white' }}
            /> */}
            </Content>
          </OverlayGradient>
        </Overlay>
      </Wrapper>
    </>
  );
};

const Wrapper = styled(Link)`
  border-radius: 10px;
  height: 100%;
  width: 100%;
  max-width: 552px;
  max-height: 552px;
`;

const Overlay = styled.div<{ src: string }>`
  border-radius: 10px;
  position: relative;
  width: 343px;
  height: 343px;
  ${(props) => (props.src ? backgroundImageMixin(props.src) : '')};

  @media only screen and ${devices.desktop} {
    width: 552px;
    height: 552px;
  }
`;

const OverlayGradient = styled.div`
  position: absolute;
  bottom: 0;
  height: 238px;
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(
    180deg,
    rgba(39, 39, 39, 0) 0%,
    rgba(39, 39, 39, 0.690322) 36.67%,
    rgba(39, 39, 39, 0.840985) 58.45%,
    #272727 100%
  );
`;

const Content = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: end;
  flex-direction: column;
  align-items: start;
`;

const Desciption = styled(Text)`
  font-size: 18px;
  color: white;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  line-clamp: 3;
`;

const Time = styled(Text)`
  font-size: 14px;
  color: rgba(176, 176, 176, 1);
  margin-bottom: 8px;
`;
